"use client"
import { type ReactNode, useState } from 'react';

type Props = {
  fullText: ReactNode;
  infoText: ReactNode;
}
export const ShowMore = ({ fullText, infoText }: Props) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <p className="text-sm text-[#B8B8B8] mt-5 max-lg:hidden">
      {showMore ? fullText : infoText}
      {!showMore && (
        <span
          className="cursor-pointer underline"
          onClick={() => setShowMore(true)}
        >
          {' '}
          En savoir plus
        </span>
      )}
    </p>
  );
};